import * as React from "react";
const SvgFiRrHandBackPointRibbon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-back-point-ribbon_svg__a)">
      <path
        fill="#062147"
        d="M17.981 9.376 12 8.18V3.107C12 1.591 10.924.273 9.497.041a3.01 3.01 0 0 0-2.439.674 3 3 0 0 0-1.057 2.29L6.004 4H2.617c-.549 0-.766.526-.378.914l1.762 1.086L2.252 7.12c-.388.388-.183.882.365.882h3.397l.006 2.274-3.945 3.92A3.62 3.62 0 0 0 1 16.77a3.62 3.62 0 0 0 1.066 2.58l2.308 2.307A7.95 7.95 0 0 0 10.031 24H17c2.757 0 5-2.243 5-5v-4.72a5.01 5.01 0 0 0-4.019-4.904M8 3a1.003 1.003 0 0 1 1.176-.986c.462.076.825.556.825 1.093V4H8.004zm12 16c0 1.654-1.346 3-3 3h-6.969a5.96 5.96 0 0 1-4.243-1.757L3.48 17.935A1.63 1.63 0 0 1 3 16.773c0-.439.172-.85.484-1.16l2.544-2.528.011 3.917a1 1 0 0 0 1 .997h.003a1 1 0 0 0 .997-1.003L8.014 8H10v1c0 .477.336.887.804.98l6.785 1.357a3.01 3.01 0 0 1 2.412 2.942V19z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-back-point-ribbon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandBackPointRibbon;
